import {
  HEALTH_STATE,
  type HealthState,
  HealthStateSchema,
} from "../enums/core";

export type { HealthState };
export { HealthStateSchema };

export function healthState(
  score: number | null,
  good: number,
  watch: number,
): HealthState {
  if (score === null) {
    return HEALTH_STATE.NODATA;
  }
  if (score >= good) {
    return HEALTH_STATE.GOOD;
  }
  if (score >= watch) {
    return HEALTH_STATE.WATCH;
  }
  return HEALTH_STATE.POOR;
}

export const PAGE_THRESHOLDS = { good: 78, watch: 55 } as const;
export const SIGNAL_THRESHOLDS = { good: 80, watch: 60 } as const;
